<template>
  <div
    class="wrapper"
  >
    <a-layout
      id="components-layout-demo-side"
      style="min-height: 100vh; border: none"
    >
      <div
        v-if="menu.length > 0 && !isMicroApp && isMenuVisible"

        class="test"
        style="background-color: white"
      >
        <a-layout-sider
          collapsible
          v-model="collapsed"
          :trigger="null"
          width="240px"
        >
          <div class="logo" :class="titleShow ? 'white' : 'black'">
            <div v-if="titleShow">
              <img
                src="@/assets/atom_side_logo.png"
                class="atom_side_logo"
                alt="logo"
              />
            </div>
            <span :class="titleShow ? 'logo' : 'logoBlack'" v-else>
              <img
                src="@/assets/atom_side_logo.png"
                class="atom_side_logo2"
                style="width: 80%"
                alt="logo"
              />
            </span>
          </div>
          <SideMenu
            theme="light"
            style="border: none"
            :showFlag="showFlag"
          ></SideMenu>
        </a-layout-sider>
      </div>
      <a-layout>
        <a-layout-header
          v-if="!isMicroApp"
          style="
            background: #050003;
            padding: 0;
            margin-top: 0px;
            height: 80px;
            line-height: 80px;
          "
        >
          <div style="float: left; color: #fff; padding-right: 30px">
            <a-icon
              v-if="menu.length > 0"
              class="trigger"
              @mouseover="mouseOver"
              @mouseleave="mouseLeave"
              :style="menuStyle"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="menuClick"
            >
            </a-icon>

            <span
              style="
                font-size: 24px;
                font-weight: bold;
                color: var(--main-color);
              "
              >Dynames</span
            >
          </div>

          <Header v-on="$listeners"></Header>
        </a-layout-header>
        <div>
          <div style="height: 5px"></div>
          <a-layout-content style="margin: 0 25px;">
            <router-view></router-view>
          </a-layout-content>
        </div>
        <!-- <div v-else>
          <no-authority></no-authority>
        </div> -->
        <a-layout-footer>
          <Footer></Footer>
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <div id="to-top-btn" v-show="toTopShow" @click="toTopClick">
      <a-icon type="caret-up" theme="filled" style="font-size: 30px" />
    </div>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer.vue";
import SideMenu from "./SideMenu.vue";
import SettingDrawer from "../components/SettingDrawer";
import NoAuthority from "../views/login/NoAuthority.vue";
import { isMcd, themeColor } from "@/utils/theme";
import { mapState } from 'vuex'; // 导入 mapState

export default {
  name: "BasicLayout",
  data() {
    return {
      isMcd, //是否是mcd风格
      styleType: "", //  mcd | atom
      menuStyle: "color: #D46910",
      titleShow: true,
      collapsed: false,
      showFlag: null, //控制所有菜单标题显示
      toTopShow: false,
      scrollTop: 0,
      menu: JSON.parse(localStorage.getItem("menu"))||[],
      isMicroApp: false,
      resizeObserver: null,
    };
  },
  mounted() {
    this.styleType = this.$store.state.style;
    this.showFlag = true;
    window.addEventListener("scroll", this.scrollToTop);
    this.menuStyle = `color: ${
      themeColor[this.$store.state.style + "ThemeColor"]
    }`;
    this.isMicroApp = !!window.__MICRO_APP_ENVIRONMENT__;
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const flag = document.documentElement.clientWidth <= 1024;
      this.collapsed = flag;
      this.titleShow = !flag;
      this.showFlag = !flag;
    },
    toTopClick() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let browserHeight = window.outerHeight;
      this.scrollTop = scrollTop;
      if (scrollTop > 220) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    menuClick() {
      this.collapsed = !this.collapsed;
      this.titleShow = !this.titleShow;
      this.showFlag = !this.showFlag;
    },
    mouseOver() {
      if (this.styleType === "mcd") {
        this.menuStyle = `color: #DB0008;background-color: ${
          themeColor[this.$store.state.style + "ThemeColor"]
        };`;
      } else {
        this.menuStyle = `color: ${themeColor["mcdThemeColor"]};background-color:rgba(5, 0, 3, 1)`;
      }
    },
    mouseLeave() {
      this.menuStyle = `color: ${
        themeColor[this.$store.state.style + "ThemeColor"]
      };background-color:#000`;
    },
  },
  computed: {
    ...mapState(['isMenuVisible']) // 获取 Vuex 中的状态
  },
  components: {
    Header,
    Footer,
    SideMenu,
    NoAuthority,
    // eslint-disable-next-line vue/no-unused-components
    SettingDrawer,
  },
};
</script>

<style lang="less" scoped>
.trigger {
  font-size: 20px;
  padding: 0px 20px;
  line-height: 64px;
  color: #f8f9ff;

  &:hover {
    background: #ffffff;
  }
}

.black {
  background-color: #050003;
}

.white {
  background-color: #050003;
}

.logo {
  line-height: 80px;
  font-weight: 600;
  font-size: 20px;
  height: 80px;
  text-align: center;
  overflow: hidden;
}

.atom_side_logo {
  margin-top: 10px;
  margin-left: -60px;
}

.atom_side_logo2 {
  margin-top: 10px;
}

.mcd-title {
  font-family: "PingFangSC-Regular";
  height: 80px;
  line-height: 80px;
  font-size: 26px;
  color: #ffbc0d;
}

.yoplait-title {
  font-family: "PingFangSC-Regular";
  height: 80px;
  line-height: 80px;
  font-size: 26px;
  color: #d46910;
}

.nav-theme-dark .logo {
  color: #ffffff;
  line-height: 64px;
  text-align: center;
}

.ant-layout-sider {
  background: white;
}

.ant-layout-sider-children {
  background-color: black !important;
}

.ant-layout-footer {
  background: #f3f3f3;
}

.wrapper {
  position: relative;
}

#to-top-btn {
  position: fixed;
  bottom: 50px;
  right: 14px;
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

#to-top-btn:hover {
  background: rgba(0, 0, 0, 0.35);
}
</style>
